import { FormControl,  Select as MuiSelect,
 FormHelperText, InputLabel, MenuItem } from '@mui/material';
import React from 'react';

const Select = (props) => {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options,
  } = props;
console.log(value)
  return (
    <FormControl variant="outlined" {...(error && { error: true })}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={value}
        onChange={onChange}
      >
        {options.map((item) => (
          <MenuItem key={item.id} value={item.name}>
            {item.name}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default Select;
